import { DevelopmentType } from "@gql/sites-api/graphql";

export const MAX_WORKSPACE_GOAL_LENGTH = 1000;
export const MAX_WORKSPACE_NAME_LENGTH = 255;
export const WORKSPACE_TITLE_ALREADY_EXISTS_CODE = "TITLE_ALREADY_EXISTS";

type DevelopmentTypeChip = {
  value: DevelopmentType;
  label: string;
  icon: string;
  iconColour: string;
};

export const DEVELOPMENT_TYPES: DevelopmentTypeChip[] = [
  {
    value: DevelopmentType.Residential,
    label: "Residential",
    icon: "icon-lt-home-line",
    iconColour: "text-icon-accent-green",
  },
  {
    value: DevelopmentType.Commercial,
    label: "Commercial",
    icon: "icon-lt-building-line",
    iconColour: "text-icon-accent-blue",
  },
  {
    value: DevelopmentType.MixedUse,
    label: "Mixed Use",
    icon: "icon-lt-community-line",
    iconColour: "text-icon-accent-amber",
  },
  {
    value: DevelopmentType.Power,
    label: "Power",
    icon: "icon-lt-flashlight-line",
    iconColour: "text-icon-accent-green",
  },
  {
    value: DevelopmentType.StudentHousing,
    label: "Student Housing",
    icon: "icon-lt-graduation-cap-line",
    iconColour: "text-background-badge-grey-accent",
  },
  {
    value: DevelopmentType.Retirement,
    label: "Retirement",
    icon: "icon-lt-service-line",
    iconColour: "text-icon-accent-red",
  },
  {
    value: DevelopmentType.Industrial,
    label: "Industrial",
    icon: "icon-lt-building-3-line",
    iconColour: "text-black",
  },
  {
    value: DevelopmentType.Other,
    label: "Other",
    icon: "icon-lt-collage-line",
    iconColour: "text-text-accent-brand-purple-primary",
  },
];

export const getDevelopmentTypeIconProps = (developmentType: DevelopmentType) => {
  const developmentTypeData = DEVELOPMENT_TYPES.find((type) => type.value === developmentType);
  return {
    icon: developmentTypeData?.icon,
    iconColour: developmentTypeData?.iconColour,
  };
};
